import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CAMPAIGNDETAIL,
  DELETE_CAMPAIGNDETAIL,
  UPDATE_CAMPAIGNDETAIL,
  ADD_NEW_CAMPAIGNDETAIL,
} from "./actionType";

import {
  getCampaignDetailSuccess,
  getCampaignDetailFail,
  deleteCampaignDetailSuccess,
  deleteCampaignDetailFail,
  updateCampaignDetailSuccess,
  updateCampaignDetailFail,
  addCampaignDetailSuccess,
  addCampaignDetailFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveCampaignDetailApi,
  getCampaignDetailApi,
  updateCampaignDetailApi,
  deleteCampaignDetailApi,
  addNewCampaignDetailApi
} from "../../helpers/backend_helper";

function* getCampaignDetail({ payload: campaignDetail }) {
  try {
    const response = yield call(getCampaignDetailApi, campaignDetail);
    yield put(getCampaignDetailSuccess(GET_CAMPAIGNDETAIL, response.data));
  } catch (error) {
    yield put(getCampaignDetailFail(GET_CAMPAIGNDETAIL, error));
  }
}

function* onUpdateCampaignDetail({ payload: campaignDetail }) {
  try {
    if (campaignDetail.setApprove) {
      const response = yield call(approveCampaignDetailApi, campaignDetail);
      yield put(updateCampaignDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCampaignDetailApi, campaignDetail);
      yield put(updateCampaignDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCampaignDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCampaignDetail({ payload: campaignDetail }) {
  try {
    const response = yield call(deleteCampaignDetailApi, campaignDetail);
    yield put(deleteCampaignDetailSuccess({ campaignDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCampaignDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCampaignDetail({ payload: campaignDetail }) {
  try {
    const response = yield call(addNewCampaignDetailApi, campaignDetail);
    yield put(addCampaignDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCampaignDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCampaignDetail() {
  yield takeEvery(GET_CAMPAIGNDETAIL, getCampaignDetail);
}

export function* watchUpdateCampaignDetail() {
  yield takeEvery(UPDATE_CAMPAIGNDETAIL, onUpdateCampaignDetail);
}

export function* watchDeleteCampaignDetail() {
  yield takeEvery(DELETE_CAMPAIGNDETAIL, onDeleteCampaignDetail);
}

export function* watchAddNewCampaignDetail() {
  yield takeEvery(ADD_NEW_CAMPAIGNDETAIL, onAddNewCampaignDetail);
}

function* campaignDetailSaga() {
  yield all([
    fork(watchGetCampaignDetail),
    fork(watchDeleteCampaignDetail),
    fork(watchUpdateCampaignDetail),
    fork(watchAddNewCampaignDetail)
  ]);
}

export default campaignDetailSaga;
